import EditorAbstractField from "./EditorAbstractField.mjs";
import EditorSubOptions from "./EditorSubOptions.mjs";
import {Input, InputGroup, InputGroupText, Label} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";

const EditorSelectField = class extends EditorAbstractField {
	field() {
		return(
			<>
				{ this.textareaField() }
				<InputGroup>
					<InputGroupText>
						<Label
							htmlFor={ this.uid + '-multi' }
						>
							<TextLabel value={"Multiple"} />
						</Label>
					</InputGroupText>
					<InputGroupText>
						<Input
							id={ this.uid + '-multi' }
							type={"checkbox"}
							checked={ !! this.state.value?.multi }
							onChange={ e => {
								this.setValue('multi', e.target.checked || undefined );
							}}
						/>
					</InputGroupText>
					<InputGroupText>
						<Label
							htmlFor={ this.uid + '-multi' }
						>
							<TextLabel value={"SelectMultiNote"} />
						</Label>
					</InputGroupText>
				</InputGroup>
				<div className={"fieldRow RadioField"}>
					<Label>
						<TextLabel value={"Options"} />
					</Label>
					<EditorSubOptions
						key={this.state.changes}
						options={this.state.value?.options}
						setValue={o => this.setValue('options', o)}
					/>
				</div>
			</>
		)
	}
}

export default EditorSelectField;